import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThongTinCaNhanComponent } from './thong-tin-ca-nhan.component'

const routes: Routes = [{ path: '', component: ThongTinCaNhanComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThongTinCaNhanRoutingModule { }
